import { getWindow } from "utils-lib/getWindow"

const ssrWindow = getWindow()

/**
 * Determines if the current path matches the /support route.
 * @param {String} path - The path to be tested for a match against the /support route.
 * @returns {Boolean} - A boolean value indicating whether the current path matches the /support route.
 */
export default (path = null) => {
  let testPath = ssrWindow.location.pathname
  if (path) {
    testPath = path
  }

  return !!testPath.match(/\/support(\/|$)/g)
}

/**
 * Checks if the current page is a support page.
 *
 * @returns {boolean} Returns true if the current page contains /support in the path.
 */
// eslint-disable-next-line max-len

export const isCurrentPageSupportPage = () =>
  ssrWindow.location.pathname.indexOf("/support") !== -1

/**
 * Checks if the current page is the support landing page.
 *
 * @returns {boolean} Returns true if the current page is the top level support landing page by checking for trailing slash after support in path
 */
// eslint-disable-next-line max-len

export const isCurrentPageSupportLandingPage = () =>
  isCurrentPageSupportPage() &&
  ssrWindow.location.pathname.indexOf("support/") === -1
